const HeaderMenu = {
  render() {
    return (
      <div class="header-index-right">
        {this.$slots.default}
      </div>
    );
  },
};

export default HeaderMenu;
